import Vue from 'vue'
import Vuex from 'vuex'
import pathify, {make} from 'vuex-pathify'
import competencesModule from './modules/competencesModule'
import experiencesModule from './modules/experiencesModule'
import hobbiesModule from './modules/hobbiesModule'

const state = {
}

const mutations = {
    ...make.mutations(state)
}

const actions = {
    ...make.actions(state)
}

const getters = {
    ...make.getters(state)
}

const store = {
    state,
    mutations,
    actions,
    getters,
    modules: {
        competencesModule,
        experiencesModule,
        hobbiesModule
    }
}

Vue.use(Vuex)
export default new Vuex.Store({
    plugins: [pathify.plugin],
    ...store
})



// WEBPACK FOOTER //
// ./src/store/index.js